import { Link } from "react-router-dom";
import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import Container from "./Container";
import axios from "axios";
import {
  GridRowModes,
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const initialRows = [
  {
    id: 1,
    Trip: "Jon Snow",
    Startdate: "jonsnow@gmail.com",
    image: 35,
    city: "New York",
    Area: "New York",
    Comping: "10001",
    Level: 123512,
    Marshall: 123512,
  },
  {
    id: 2,
    Trip: "Jon Snow",
    Startdate: "jonsnow@gmail.com",
    image: 35,
    city: "New York",
    Area: "New York",
    Comping: "10001",
    Level: 123512,
    Marshall: 123512,
  },
];
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <Box className="div-btn-header">
          <Button
            component={Link}
            variant="contained"
            className="btn-submit"
            color="secondary"
            to="/create-Fund"
          >
            اضافة رصيد
          </Button>
        </Box>
      </GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Fund = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [users, setUsers] = useState([]);
  const [r, setr] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState(initialRows);
  const [fundname, setfundName] = React.useState();
  const [id, setfundId] = React.useState([]);

  const [fundtype, setfundType] = React.useState();
  const [fundtype1, setfundType1] = React.useState();
  const [fundtype2, setfundType2] = React.useState();
  const [fundtype3, setfundType3] = React.useState();
  const [fundtype4, setfundType4] = React.useState();
  const [fundcompany, setfundCompany] = React.useState([]);
  const [pricegeneral, setPriceGeneral] = React.useState([]);
  const [priceprivate, setPricePrivate] = React.useState([]);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        `${BaseUrl}/api/getUnitfund`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(res.data);

        setr(res.data.fund_type);

        setIsLoading(false);
        setfundType(
          res.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_name: n.fund_name },
          }))
        );

        setfundType1(
          res.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_type: n.fund_type },
          }))
        );

        setfundType2(
          res.data.map((n) => ({
            ...id,
            ["p"]: { id: n.id, fund_company: n.fund_company },
          }))
        );
        setfundType3(
          res.data.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              price_for_general_distributor: n.price_for_general_distributor,
            },
          }))
        );
        setfundType4(
          res.data.map((n) => ({
            ...id,
            ["p"]: {
              id: n.id,
              price_for_special_distributor: n.price_for_special_distributor,
            },
          }))
        );
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleDeleteClick = (id) => () => {
    const config = {
      headers: { "Content-Type": "application/json", Authorization: null },
    };
    axios
      .delete(
        `${BaseUrl}/api/deleteFund/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(users.filter((row) => row.id !== id));
      })
      .catch((err) => {});
  };

  const triggerText = "تعديل";

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const columns = [
    {
      field: "fund_name",
      headerName: "اسم الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "fund_type",
      headerName: "النوع",
      type: "number",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
      valueGetter: (params) => {
        setr(params.row.fund_type);

        return params.row.fund_type;
      },
    },
    {
      field: "fund_company",
      headerName: "اسم الشركة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "actions",
      renderCell: ({ id }) => {
        return (
          <Box className="editbtn">
            <Container
              triggerText={triggerText}
              fundname={fundname}
              id={id}
              fundtype={fundtype}
              fundtype1={fundtype1}
              fundtype2={fundtype2}
              fundtype3={fundtype3}
              fundtype4={fundtype4}
              fundcompany={fundcompany}
              pricegeneral={pricegeneral}
              priceprivate={priceprivate}
            />
            <Button
              variant="contained"
              color="primary"
              className="deletebtn"
              onClick={handleDeleteClick(id)}
            >
              حذف
              <img
                src="deleteicon.svg"
                className="icondelete"
                alt="delete icon"
              ></img>
            </Button>
          </Box>
        );
      },
    },
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          columns={columns}
          className="field-table"
          editMode="row"
          pageSize={10}
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',
        }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default Fund;
